import { buildPageOrderBy } from './sort-direction';
import { buildCursorTerm } from './cursor-term';

const INITIAL_POSITION = { cursor: null, history: [] };

// Going "back" re-issues the original onward query for an earlier page rather than querying the
// opposite direction from the current position — an opposite-direction query would need an
// inclusive comparator on one side and could drop or duplicate the row sitting on the cursor.
function buildPageVariables({ scopeWhere, filterWhere, pageSize, position, direction }) {
  const cursorTerm = buildCursorTerm(position.cursor, direction);
  return {
    where: { _and: [scopeWhere, filterWhere, ...(cursorTerm ? [cursorTerm] : [])] },
    orderBy: buildPageOrderBy(direction),
    limit: pageSize + 1,
    offset: 0,
  };
}

// timestampRaw, never timestamp: the latter is the display Date, and a Date cursor truncates
// Postgres microseconds, which drops any row inside the truncated window at the page boundary.
function readPageInfo({ rows, fetchedCount, pageSize, position }) {
  const hasNextPage = fetchedCount > pageSize;
  const lastRow = rows[rows.length - 1];
  const nextPosition =
    hasNextPage && lastRow
      ? {
          cursor: { timestamp: lastRow.timestampRaw, id: lastRow.id },
          history: [...position.history, position.cursor],
        }
      : null;
  const prevPosition =
    position.history.length > 0
      ? {
          cursor: position.history[position.history.length - 1],
          history: position.history.slice(0, -1),
        }
      : null;
  return { hasNextPage, nextPosition, prevPosition };
}

export default {
  initialPosition: INITIAL_POSITION,
  buildPageVariables,
  readPageInfo,
  totalCountDocument: null,
};
